import { render, staticRenderFns } from "./LandingDesktop.vue?vue&type=template&id=068b804a&scoped=true&"
import script from "./LandingDesktop.vue?vue&type=script&lang=js&"
export * from "./LandingDesktop.vue?vue&type=script&lang=js&"
import style0 from "./LandingDesktop.vue?vue&type=style&index=0&id=068b804a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068b804a",
  null
  
)

export default component.exports